/**
 * Border radius tokens from Figma design system
 *
 * Values are in pixels. Use with theme.shape.borderRadius or directly.
 */

export const radii = {
  'extra-extra-small': 2,
  'extra-small': 4,
  small: 8,
  medium: 12,
  large: 16,
  'extra-large': 28,
  'fully-rounded': 100,
} as const;

export type Radii = typeof radii;
